// AppLeftNav.js
import React from 'react';
import PropTypes from 'prop-types';
//import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
//import IconButton from '@material-ui/core/IconButton';
//import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { WhereToVote, 
  //Equalizer, Router, 
  ViewList } from '@material-ui/icons';
//import MailIcon from '@material-ui/icons/Mail';
//import MenuIcon from '@material-ui/icons/Menu';
//import Toolbar from '@material-ui/core/Toolbar';
//import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const drawerWidth = 180;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));
  
function AppLeftNav(props) {
  const { window, mobileOpen, handleDrawerToggle, setDrawer, user } = props;
  const classes = useStyles();
  const theme = useTheme();
	
  const handleCloseDrawer = () => {
	  setDrawer(false);
  };
  if(!user || !user.usergroup) return '';
  
/*
<ListItem button component={Link} onClick={handleCloseDrawer} to="/stats" key="Stats">
	  		<ListItemIcon>
	  			<Equalizer />
	  		</ListItemIcon>
	  		<ListItemText primary="Stats" />
	  	</ListItem>
	  	<Divider />
	  	<ListItem button component={Link} onClick={handleCloseDrawer} to="/modems" key="Modems">
	  		<ListItemIcon>
	  			<Router />
	  		</ListItemIcon>
	  		<ListItemText primary="Modems" />
	  	</ListItem>
*/

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List>
	  	<ListItem button component={Link} onClick={handleCloseDrawer} to="/map" key="Map">
	  		<ListItemIcon>
	  			<WhereToVote />
	  		</ListItemIcon>
	  		<ListItemText primary="Map" />
	  	</ListItem>
	  	<Divider />
	  	<ListItem button component={Link} onClick={handleCloseDrawer} to="/signs" key="Signs">
	  		<ListItemIcon>
	  			<ViewList />
	  		</ListItemIcon>
	  		<ListItemText primary="Signs" />
	  	</ListItem>
	  	<Divider />
	  	
      
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden mdUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    </div>
  );
}

AppLeftNav.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  mobileOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  window: PropTypes.func,
};

export default AppLeftNav;
